<template>
    <div>
        <RenovarBase/>
    </div>
</template>

<script>
    import RenovarBase from "@/components/frontend/bases/renovar/RenovarBase";
    import {useHead} from "@/composables/common/seo/useHead";

    export default {
        created() {
            if (!this.footer.renovacion_futbol_base || this.footer.ocultar_renovacion_futbol_base || this.footer.activar_compra_por_invitacion_bases && localStorage.getItem('codigo_invitacion') == null) {
                this.$router.push({ name: 'front.home'});
            }
            useHead('Renovar cantera');
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            footer() {
                return this.$store.getters.getFooter;
            }
        },
        components: { RenovarBase }
    }
</script>